import { useContext } from 'react';
import { LoadingOverlayContext } from './provider';

export const useLoadingOverlay = () => useContext(LoadingOverlayContext);
